import { useLazyQuery } from '@apollo/client/react';
import { useEffect, useMemo } from 'react';

import { GetAppointmentOnAppointmentFileMenuDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { useSubscriptions } from '~/hooks/use-subscriptions';

type Props = {
  appointmentId: string | null | undefined;
};

export const useFetchPrescriptionStatus = ({ appointmentId }: Props) => {
  const [event, clear] = useSubscriptions('Appointment', ['updated']);
  const [getAppointment, { data, loading, called }] = useLazyQuery(
    GetAppointmentOnAppointmentFileMenuDocument,
    {
      fetchPolicy: 'network-only',
    },
  );

  const appointment = useMemo(() => {
    return getNode(data, 'Appointment');
  }, [data]);

  useEffect(() => {
    if (appointmentId) {
      getAppointment({
        variables: {
          id: appointmentId,
        },
      });
    }
  }, [appointmentId, getAppointment]);

  useEffect(() => {
    if (!data || !event) return;

    clear();
  }, [clear, data, event]);

  useEffect(() => {
    if (event?.actionName === 'updated' && event.typeId === appointmentId) {
      getAppointment({
        variables: {
          id: appointmentId,
        },
      });
    }
  }, [appointmentId, event?.actionName, event?.typeId, getAppointment]);

  const status = useMemo(() => {
    if (
      appointment?.pfDispensingRequestUploadType === 'app' ||
      appointment?.pfDispensingRequestUploadType === 'medical_institution'
    ) {
      return {
        label: 'データあり',
        active: true,
      };
    }

    return {
      label: 'データなし',
      active: true,
    };
  }, [appointment]);

  return {
    status,
    loading: loading || !called,
    appointment,
  };
};
